'use client'

import { useTranslations } from 'next-intl'

import { LeaderboardEmptyState } from './LeaderboardEmptyState'

/** The first page did not load: say so instead of "Nothing found". */
export function LeaderboardLoadError({ onRetry }: { onRetry: () => void }) {
  const t = useTranslations('leaderboardBoard.loadError')
  return (
    <LeaderboardEmptyState
      title={t('title')}
      description={t('description')}
      actionLabel={t('retry')}
      onAction={onRetry}
    />
  )
}
